import React, { useState, useRef } from 'react'
import { translate } from 'react-i18next'
import MaskedInput from 'react-text-mask'

import './style.css'

const Feedback = ({ t }) => {

    const [name, setName] = useState('')
    const [phone, setPhone] = useState('')
    const [email, setEmail] = useState('')
    const [comment, setComment] = useState('')

    const notificationText = useRef(null)
    const submitButton = useRef(null)

    const onSubmit = (e) => {
        e.preventDefault()
        if (submitButton.current)
            submitButton.current.disabled = true

        if (!checkPhone(phone)) {
            if (notificationText.current) {
                submitButton.current.disabled = false
                notificationText.current.classList.add('feedback__notification--error')
                notificationText.current.innerHTML = t('feedback.notification.phone')
            }
        } else if (!checkEmail(email) && email.length > 0) {
            if (notificationText.current) {
                submitButton.current.disabled = false
                notificationText.current.classList.add('feedback__notification--error')
                notificationText.current.innerHTML = t('feedback.notification.email')
            }
        } else {
            const data = { form: 'feedback', name, phone, email, comment }

            fetch("https://emalion.clockwork.one/send?app=clockwork", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(data)
            }).then((res) => {
                if(res.ok)
                    return res.json()
                throw Error(`Error with status: ${ res.statusText }`)
            }).then(({ http_code }) => {
                if(http_code === 200) {
                    if (notificationText.current) {
                        notificationText.current.classList.remove('feedback__notification--error')
                        notificationText.current.classList.add('feedback__notification--success')
                        notificationText.current.innerHTML = t('feedback.notification.success')
                    }
                } else {
                    if (notificationText.current) {
                        submitButton.current.disabled = false
                        notificationText.current.classList.add('feedback__notification--error')
                        notificationText.current.innerHTML = t('feedback.notification.error')
                    }
                }
            }).catch((err) => {
                console.error(err)
                submitButton.current.disabled = false
                if (notificationText.current) {
                    submitButton.current.disabled = false
                    notificationText.current.classList.add('feedback__notification--error')
                    notificationText.current.innerHTML = t('feedback.notification.error')
                }
            })
        }
    }

    const checkPhone = (phone) => {
        const pattern = /^\(\d{3}\)\s\d{3}-\d{4}/
        return pattern.test(phone)
    }

    const checkEmail = (email) => {
        // eslint-disable-next-line
        const pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(String(email).toLowerCase())
    }

    return (
        <div className="feedback">
            <h2 className="feedback__title">{ t('feedback.title') }</h2>
            <p className="feedback__text">{ t('feedback.description') }</p>
            <p className="feedback__text">{ t('feedback.call') }: <a href="tel:+79135703222" className="feedback__phone">+7 (913) 570-32-22</a></p>
            <form className="feedback__form" onSubmit={ onSubmit }>
                <div className="form__group feedback__form__name">
                    <label className="form__group__label">{ t('feedback.form.name') }<sup>*</sup></label>
                    <input type="text" name="name" onChange={ ({ target: { value } }) => setName(value) } value={ name } required  />
                </div>
                <div className="form__group feedback__form__phone">
                    <label className="form__group__label">{ t('feedback.form.phone') }<sup>*</sup></label>
                    <MaskedInput mask={['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
                                 name="phone"
                                 required
                                 value={ phone }
                                 onChange={ ({ target: { value } }) => setPhone(value) } />
                </div>
                <div className="form__group feedback__form__email">
                    <label className="form__group__label">{ t('feedback.form.email') }</label>
                    <input type="email" name="email" onChange={ ({ target: { value } }) => setEmail(value) } value={ email } />
                </div>
                <div className="form__group feedback__form__comment">
                    <label className="form__group__label">{ t('feedback.form.comment') }</label>
                    <textarea name="comment" rows={ 3 } onChange={ ({ target: { value } }) => setComment(value) } value={ comment } />
                </div>
                <div className="form__group feedback__form__submit">
                    <button type="submit" ref={ submitButton }>{ t('feedback.form.submit') }</button>
                </div>
            </form>
            <small className="feedback__notification" ref={ notificationText } />
        </div>
    )
}

export default translate('translations')(Feedback)


// WEBPACK FOOTER //
// ./src/Feedback/index.js